import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ToolbarService,GroupService } from '@syncfusion/ej2-angular-grids';
import { DetailRowService } from '@syncfusion/ej2-angular-grids';
import { SortService } from '@syncfusion/ej2-angular-grids';

@Component({
  selector: 'app-tickets',
  templateUrl: './tickets.component.html',
  styleUrls: ['./tickets.component.css'],
  providers: [DetailRowService,SortService,ToolbarService,GroupService]
})
export class TicketsComponent implements OnInit {
  @ViewChild('ticketstable') ticketstable:any;
  ticketsInCorso:any[]=[];
  public toolbar: string[];
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.toolbar = ['Search'];
    let tic=[];


    let params= {id_user:this.globalService.loggedUser.id};
    this.apiService.get('users/logininfokpi',params).subscribe(data => {
      let params=data.Result[0];
      this.apiService.get('todo/ticketdicompetenza',params).subscribe(data => {
        this.ticketsInCorso=data.Result;
        this.ticketstable.localeObj.currentLocale.EmptyRecord = 'Nessun dato da visualizzare ...'; 
        this.ticketstable.refresh();
  
      });
    });
  }

  goto(){                      
    this.router.navigateByUrl('/java/arkiweb/login/LogonServletAw?oper=3&redirectS=ServletTicket');
    
  }
  onLoad() { 
    this.ticketstable.localeObj.currentLocale.EmptyRecord = 'Caricamento in corso...'; 
  }


  apri(data){
    
   
    if(data.modulo=='ticket'){
      let logInfo = JSON.parse(localStorage.getItem("logInfo"));
      let params={
        password:logInfo.password,
        userNamelogin:logInfo.username
      }

      this.globalService.submitForm('arkiweb/login/LogonServletAw?oper=3&redirectS=ServletTicket&id_ticket='+data.id,'POST',params);
    }
  }

}
